export default __webpack_public_path__ + "static/media/Norxit-eng.bd50d2e7.jpg";